/* eslint-disable @typescript-eslint/no-unused-vars */
import Grid from '@material-ui/core/Grid'
import Moment from 'moment'
import MomentJalaali from 'moment-jalaali'
import React from 'react'

import { getTimeView } from '../../../../helpers/date'
import { CustomMonthViewProps } from '../types/DateRangePicker.types'
import WeekDayNamesView from './WeekDayNamesView'
import useStyles from './styles/monthView.style'

const CustomMonthViewMultiDates: React.FC<CustomMonthViewProps> = (props) => {
  const classes = useStyles()
  const {
    data = [],
    name,
    currentMonth,
    currentYear,
    currentMonthFirstDay,
    selectedStartDate,
    selectedEndDate,
    hoveredDate,
    selectFromPast,
    selectAllDays,
    onSelectStartDate,
    onSelectEndDate,
    onHoverDate,
    lastSelectedDateRangeType,
    type,
    showJalaaliHolidays,
    range,
    multipleDates,
    selectedDatesList,
    todayDay
  } = props

  const startDateIsFromCurrentMonth =
    selectedStartDate && currentMonth === selectedStartDate.split('-')[1]

  const endDateIsFromCurrentMonth =
    selectedEndDate && currentMonth === selectedEndDate.split('-')[1]

  const hoveredDateIsFromCurrentMonth =
    hoveredDate && currentMonth === hoveredDate.split('-')[1]

  const selectedStartDateDay = selectedStartDate
    ? parseInt(selectedStartDate.split('-')[2], 10)
    : 0

  const selectedEndDateDay = selectedEndDate
    ? parseInt(selectedEndDate.split('-')[2], 10)
    : 0

  const hoveredDateIsFromNextMonths = hoveredDate
    ? hoveredDate.split('-')[1] > currentMonth
    : ''

  const endDateIsFromNextMonths = selectedEndDate
    ? selectedEndDate.split('-')[1] > currentMonth
    : ''

  const startDateIsFromPreviousMonths = selectedStartDate
    ? selectedStartDate.split('-')[1] < currentMonth
    : ''

  const hoveredDateDay = hoveredDate
    ? parseInt(hoveredDate.split('-')[2], 10)
    : ''

  const startOfMonth =
    type === 'jalaali'
      ? MomentJalaali().startOf('jMonth')
      : Moment().startOf('month')

  // eslint-disable-next-line no-nested-ternary
  const currentMonthIsBeforeTodayMonth = selectAllDays
    ? false
    : selectFromPast
    ? currentMonthFirstDay >
      startOfMonth.clone().format(getTimeView(type).basicView)
    : currentMonthFirstDay <
      startOfMonth.clone().format(getTimeView(type).basicView)

  const todayIsInCurrentMonth =
    currentMonthFirstDay ===
    startOfMonth.clone().format(getTimeView(type).basicView)

  // const todayDay =
  //   type === 'jalaali'
  //     ? parseInt(MomentJalaali().format(getTimeView(type).dayView), 10)
  //     : parseInt(Moment().format(getTimeView(type).dayView), 10)

  const monthIsBetweenStartDateEndDateOrStartDateHoverDate =
    (startDateIsFromPreviousMonths && endDateIsFromNextMonths) ||
    (startDateIsFromPreviousMonths && hoveredDateIsFromNextMonths)

  const onClickDate = (selectedDay: number) => {
    const selectedDate = `${currentYear}-${currentMonth}-${
      selectedDay < 10 ? '0' : ''
    }${selectedDay}`
    if (selectedDay) {
      if (
        selectedStartDate &&
        selectedDate > selectedStartDate &&
        lastSelectedDateRangeType === 'START_DATE' &&
        range
      ) {
        onSelectEndDate(selectedDay)
      } else {
        onSelectStartDate(selectedDay)
      }
    }
  }

  const onHoveredDate = (newHoveredDate: number) => {
    if (newHoveredDate) {
      onHoverDate(newHoveredDate)
    }
  }

  return (
    <Grid className={classes.rootGrid}>
      <Grid container direction="column">
        <Grid item className={classes.monthContainer}>
          <span className={classes.monthName}>{name}</span>
          &nbsp;
          <span className={classes.monthName}>{currentYear}</span>
        </Grid>
        <Grid item className={classes.weekDayNamesGridItem}>
          <WeekDayNamesView
            type={type}
            onClick={(weekDayIndex) => {
              const newDatesToBeSelected: number[] = []
              data.forEach((singleDay, index) => {
                if (index % 7 === weekDayIndex % 7) {
                  newDatesToBeSelected.push(singleDay)
                }
              })
              newDatesToBeSelected.reverse()
              const selectNewDatesInterval = setInterval(() => {
                if (newDatesToBeSelected.length === 0) {
                  clearInterval(selectNewDatesInterval)
                } else {
                  const tmp = newDatesToBeSelected.pop()
                  if (tmp) {
                    onClickDate(tmp)
                  }
                }
              }, 60)
            }}
          />
        </Grid>
        <Grid item>
          <Grid container className={classes.monthContainer}>
            {(currentMonthIsBeforeTodayMonth &&
              data.map((singleDay, index) => {
                return (
                  <span
                    key={name + index.toString()}
                    className={[
                      classes.dayDefaultStyle,
                      singleDay ? classes.validDayDefaultStyle : '',
                      classes.disabledDay
                    ].join(' ')}>
                    {singleDay}
                  </span>
                )
              })) ||
              data.map((singleDay, index) => {
                // const today = parseInt(singleDay, 10)
                const today = singleDay
                return (
                  <span
                    key={name + index.toString()}
                    className={[
                      classes.dayDefaultStyle,
                      singleDay ? classes.validDayDefaultStyle : '',
                      selectedStartDateDay === today ||
                      (!range && selectedDatesList?.includes(today))
                        ? classes.selectedStartDate
                        : '',
                      selectedEndDateDay === today
                        ? classes.selectedEndDate
                        : '',
                      today > selectedStartDateDay &&
                      today < selectedEndDateDay &&
                      range
                        ? classes.inBetweenDays
                        : '',
                      todayIsInCurrentMonth &&
                      !selectAllDays &&
                      ((selectFromPast && today > todayDay) ||
                        (!selectFromPast && today < todayDay))
                        ? classes.disabledDay
                        : ''
                    ].join(' ')}
                    onClick={() => {
                      if (
                        !(
                          todayIsInCurrentMonth &&
                          !selectAllDays &&
                          ((selectFromPast && today > todayDay) ||
                            (!selectFromPast && today < todayDay))
                        )
                      ) {
                        onClickDate(singleDay)
                      }
                    }}
                    onMouseEnter={() => onHoveredDate(singleDay)}>
                    {singleDay}
                  </span>
                )
              })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CustomMonthViewMultiDates
